import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectIsUnrecoverableErrorMode } from '../error/store/error.selectors';
import { AppState } from '../core.state';

@Injectable({
    providedIn: 'root'
})
export class ErrorGuard implements CanActivate {
    constructor(private store: Store<AppState>) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.store.pipe(
            select(selectIsUnrecoverableErrorMode),
            map(isUnrecoverableErrorMode => !isUnrecoverableErrorMode)
        );
    }
}
